import { tracked } from '@glimmer/tracking';
import { errorMessage } from 'repl-sdk';
import { g, i } from 'decorator-transforms/runtime-esm';

const RESOLVE = Symbol('CompileState::resolve');
const REJECT = Symbol('CompileState::reject');
class CompileState {
  static {
    g(this.prototype, "component", [tracked]);
  }
  #component = (i(this, "component"), void 0);
  static {
    g(this.prototype, "error", [tracked]);
  }
  #error = (i(this, "error"), void 0);
  static {
    g(this.prototype, "isReady", [tracked], function () {
      return false;
    });
  }
  #isReady = (i(this, "isReady"), void 0);
  #data;
  #resolve;
  #reject;
  #promise = new Promise((resolve, reject) => {
    this.#resolve = resolve;
    this.#reject = reject;
  });
  constructor(data) {
    this.#data = data;
  }
  get format() {
    return this.#data.format;
  }
  get reason() {
    return this.error ? errorMessage(this.error) : undefined;
  }
  get isWaiting() {
    return !this.isReady && !this.error;
  }
  get promise() {
    return this.#promise;
  }

  /**
   * @private
   */
  [RESOLVE](component) {
    this.isReady = true;
    this.component = component;
    this.#resolve?.(component);
  }
  /**
   * @private
   */
  [REJECT](error) {
    this.error = error;
    this.#reject?.(error);
  }
}
class MissingTextState extends CompileState {}
class CachedCompileState extends CompileState {
  #resolvedPromise;
  constructor(data, component) {
    super(data);
    this.component = component;
    this.#resolvedPromise = Promise.resolve(component);
    this.isReady = true;
  }
  get promise() {
    return this.#resolvedPromise;
  }
}

export { CachedCompileState, CompileState, MissingTextState, REJECT, RESOLVE };
//# sourceMappingURL=state.js.map
